export default __webpack_public_path__ + "static/media/Messages.6b32f894.svg";